import { ApplicationRoles } from '../../../constants/applicationRoles.ts';
import applicationRoutes from '../../../constants/applicationRoutes.ts';
import Layout from '../../../app/Layout.tsx';
import { RouteAuthenticationRequirement, RouteItem } from '@cks-internal/react-base';

export const CrmNavItems: RouteItem = {
  text: 'CRM',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [ApplicationRoles.crm],
  layout: <Layout />,
  subItems: [
    {
      text: 'Manage Hotels',
      path: applicationRoutes.crm.hotelsNew.list,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.crm],
      async lazy() {
        const component = await import('../../../features/hotelCrm/overview/HotelManagement.tsx');
        return { Component: component.HotelManagement };
      }
    },
    {
      text: 'Hotel Rate Import',
      path: applicationRoutes.crm.hotelsNew.rateImport,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.crm],
      async lazy() {
        const component = await import('../../../features/hotelCrm/rateImport/HotelRateImport');
        return { Component: component.HotelRateImport };
      }
    },
    {
      text: 'Manage Companies',
      path: applicationRoutes.crm.companiesNew.list,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.crm],
      async lazy() {
        const component = await import('../../../features/company/overview/CompanyManagement.tsx');
        return { Component: component.CompanyManagement };
      }
    },
    {
      text: 'Manage OBT Users',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.crm.obtUsers,
      allowedRoles: [ApplicationRoles.crm],
      async lazy() {
        const component = await import('../../../features/userAdmin/ManageObtUsers.tsx');
        return { Component: component.ManageObtUsers };
      }
    },
    {
      text: 'Manage Leads',
      path: applicationRoutes.crm.leads.list,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.crm],
      async lazy() {
        const component = await import('../../../features/leads/LeadManagement.tsx');
        return { Component: component.LeadManagement };
      }
    },
    {
      text: 'Manage Cities',
      path: applicationRoutes.crm.address.list,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.crm],
      async lazy() {
        const component = await import('../../../features/crm/address/AddressManagement.tsx');
        return { Component: component.AddressManagement };
      }
    },
    {
      text: 'Manage Postmark',
      path: applicationRoutes.crm.postmark.list,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.crm],
      async lazy() {
        const component = await import('../../../features/postmark/ManagePostmark.tsx');
        return { Component: component.ManagePostmark };
      }
    },
    {
      text: 'Manage Tax Rates',
      path: applicationRoutes.crm.taxRates,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.crm],
      async lazy() {
        const component = await import('../../../features/crmAdmin/taxConfiguration/TaxConfigurationManagement.tsx');
        return { Component: component.TaxConfigurationManagement };
      }
    },
    {
      path: applicationRoutes.crm.companyContact,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [ApplicationRoles.crm],
      async lazy() {
        const component = await import('../../../features/company/companyContact/CompanyContactPage.tsx');
        return { Component: component.CompanyContactPage };
      }
    }
  ]
};
